module.exports = __webpack_public_path__ + "static/media/kennedy_solmonte_rothell_patton.c2f9d3b2.jpg";